export const CLINIC_ROLE_TRANSLATIONS = {
  manager: {
    "pt-BR": "Administrador",
    en: "Administrator",
    es: "Administrador",
    de: "Administratorin",
  },
  therapist: {
    "pt-BR": "Profissional",
    en: "Professional",
    es: "Profesional",
    de: "Fachkraft",
  },
  secretary: {
    "pt-BR": "Secretária",
    en: "Secretary",
    es: "Secretaria",
    de: "Sekretärin",
  },
  finance: {
    "pt-BR": "Financeiro",
    en: "Finance",
    es: "Finanzas",
    de: "Finanzen",
  },
} as const;

export const CLINIC_PATIENT_BADGE_TRANSLATIONS = {
  primary: { "pt-BR": "Primário", en: "Primary", es: "Primario" , de: "Primär"},
  shared: {
    "pt-BR": "Compartilhado",
    en: "Shared",
    es: "Compartido",
    de: "Geteilt",
  },
  orphan: {
    "pt-BR": "Sem responsável",
    en: "No primary",
    es: "Sin responsable",
    de: "Ohne Verantwortliche",
  },
} as const;

export const CLINIC_ORPHAN_ASSIGN_TRANSLATIONS = {
  scopeOrphans: {
    "pt-BR": "Sem responsável",
    en: "No primary",
    es: "Sin responsable",
    de: "Ohne Verantwortliche",
  },
  assignPrimary: {
    "pt-BR": "Atribuir responsável",
    en: "Assign primary",
    es: "Asignar responsable",
    de: "Verantwortliche zuweisen",
  },
  assignTitle: {
    "pt-BR": "Atribuir responsável",
    en: "Assign primary therapist",
    es: "Asignar responsable",
    de: "Primäre Fachkraft zuweisen",
  },
  assignBody: {
    "pt-BR": "Escolha um profissional ativo da clínica para {name}. O histórico clínico permanece com os profissionais anteriores.",
    en: "Choose an active clinic professional for {name}. Clinical history stays with previous professionals.",
    es: "Elige un profesional activo de la clínica para {name}. El historial clínico permanece con los profesionales anteriores.",
    de: "Wählen Sie eine aktive Klinikfachkraft für {name}. Die klinische Historie bleibt bei den bisherigen Fachkräften.",
  },
  professionalLabel: {
    "pt-BR": "Profissional responsável",
    en: "Responsible professional",
    es: "Profesional responsable",
    de: "Verantwortliche Fachkraft",
  },
  selectProfessional: {
    "pt-BR": "Selecione um profissional",
    en: "Select a professional",
    es: "Selecciona un profesional",
    de: "Fachkraft auswählen",
  },
  noEligibleTherapists: {
    "pt-BR": "Não há profissionais ativos elegíveis nesta clínica.",
    en: "There are no eligible active professionals in this clinic.",
    es: "No hay profesionales activos elegibles en esta clínica.",
    de: "In dieser Klinik gibt es keine geeigneten aktiven Fachkräfte.",
  },
  assigning: {
    "pt-BR": "Atribuindo…",
    en: "Assigning…",
    es: "Asignando…",
    de: "Zuweisen…",
  },
  assignedToast: {
    "pt-BR": "Responsável atribuído.",
    en: "Primary therapist assigned.",
    es: "Responsable asignado.",
    de: "Primäre Fachkraft zugewiesen.",
  },
  assignFailed: {
    "pt-BR": "Não foi possível atribuir o responsável.",
    en: "Could not assign the primary therapist.",
    es: "No se pudo asignar el responsable.",
    de: "Die primäre Fachkraft konnte nicht zugewiesen werden.",
  },
  cancel: { "pt-BR": "Cancelar", en: "Cancel", es: "Cancelar", de: "Abbrechen" },
} as const;

export const CLINIC_TEAM_SECTION_TRANSLATIONS = {
  specialtyUnknown: {
    "pt-BR": "Sem especialidade",
    en: "No specialty",
    es: "Sin especialidad",
    de: "Keine Spezialität",
  },
} as const;

export const CLINIC_SETTINGS_TRANSLATIONS = {
  eyebrow: { "pt-BR": "Clínica", en: "Clinic", es: "Clínica" , de: "Klinik"},
  title: { "pt-BR": "Configurações", en: "Settings", es: "Configuración" , de: "Einstellungen"},
  subtitleNamed: {
    "pt-BR": "Configurações da organização · {name}",
    en: "Organization settings · {name}",
    es: "Configuración de la organización · {name}",
    de: "Organisationseinstellungen · {name}",
  },
  subtitle: {
    "pt-BR": "Configurações da organização",
    en: "Organization settings",
    es: "Configuración de la organización",
    de: "Organisationseinstellungen",
  },
  importData: {
    "pt-BR": "Importar dados",
    en: "Import data",
    es: "Importar datos",
    de: "Daten importieren",
  },
} as const;
